import { api } from "..";

export const clearSportsCache = async (): Promise<{ success: boolean }> => {
  const res = await api.client.post("/sports-new/clear-cache");
  return res.data;
};
